import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export interface Y42RouteReuseData {
  reuseKey?: string;
}

@Injectable({ providedIn: 'root' })
export class Y42RouteReuseStrategyService extends BaseRouteReuseStrategy {
  constructor() {
    super();
  }

  override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    const currentReuseKey = (current.data as Y42RouteReuseData | undefined)?.reuseKey;
    const futureReuseKey = (future.data as Y42RouteReuseData | undefined)?.reuseKey;

    if (currentReuseKey && futureReuseKey) {
      return currentReuseKey === futureReuseKey;
    }

    return super.shouldReuseRoute(future, current);
  }
}
